//Import principale, rende Shark disponibile in questo file js.
//Dal modulo shark-core è possibile importare anche la classe "Utils" che espone alcuni metodi statici per elaborare i dati.
//Da notare che visto che stiamo importando da un modulo NPM, possiamo omettere il percorso e dichiarare solo il nome del modulo.
import { Shark } from "shark-mvc";
import moment from "moment";
import $ from "jquery";

import { TADManager } from "tad-core";
import { loginView } from "Views/loginView";


//Import della prima view che verrà aperta dall'applicazione. Se ci dovesse essere un if o simile che porta ad aprire una view o un'altra a seconda di qualche variabile, bisogna importarle tutte.


//Dato che questa app di esempio è basata su Bootstrap 4 importo gli elementi che gli servono. Non è necessario replicare questi import nelle altre pagine poiché una volta importati questi file restano disponibili per tutti i moduli che creeremo.
import "jquery";
import "popper.js";
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

// Import dei font Font Awesome
// import '@fortawesome/fontawesome-free/js/all';

//Import di eventuali file personali legati all'app: in questo caso il CSS custom dell'app.
import "./css/custom.css";
import { driverManager } from "./_shark_jaws/managers/driverManager";
import { homeView } from "./_shark_jaws/views/homeView";

//Da questa riga comincia la vera e propria applicazione, eventuale inizializzazione della libreria per gestire la comunicazione col server (sia TAD che NousCore prevedono un init per impostare l'end point di base).

//Impostiamo il livello di log di Shark. Il default è TRACE_WARN che va bene in semi-produzione, ma per lo sviluppo meglio lavorare con TRACE_LOG che logga TUTTO.
Shark.traceLevel = Shark.TRACE_LOG;
//Shark.traceLevel = Shark.TRACE_INFO;
//Shark.traceLevel = Shark.TRACE_NONE;

//Inizializzazione di Shark, serve solo una volta e prepara tutto il necessario... In una versione futura potrebbe non essere più necessaria.
Shark.init({
	enableMainStoreAutoRender: true,
	routingMethod: "url"
});
//Paramentro callEncoding, di default è "JSON" e può essere omesso mentre se si vuole specificare form-data va indicato callEncoding: "form-data"
TADManager.init({
	callEncoding: "json",
	endPointBase: "https://api.ictec.it/carbappv1/"
});

//Qui si comincia la logica: si possono dichiarare eventuali variabili globali che devono essere già pronte all'avvio, effettuare controlli e gestione del localStorage o altro simile e, più generale, tutto quello che deve essere fatto prima ancora di aprire la prima schermata.
//In una versione futura Shark mostrerà, in automatico, un waitbox fino all'apertura della prima pagina.
// Shark.set("activeItems", Shark.getModelInstance("ActiveItems"));
// Shark.set("currUser", Shark.getInstance("User"));

//Ad esempio tutta la parte sotto serve a gestire il localStorage separato per ogni window del browser.
//In una versione futura di Shark questa logica sarà implementata a livello di sistema.
if (window.name === "") {
	window.name = Shark.__generateGUID();
}

var windowData = localStorage.getItem("win_" + window.name);

if (windowData) {
	windowData = JSON.parse(windowData);
}
else {
	windowData = {};
}

windowData.lastRefresh = new Date().getTime();
localStorage.setItem("win_" + window.name, JSON.stringify(windowData));

for (var item in localStorage) {
	if (item.substr(0, 4) === "win_") {
		var itemData = JSON.parse(localStorage.getItem(item));

		if (itemData.lastRefresh) {
			if (itemData.lastRefresh < new Date().getTime() - 86400000) {
				localStorage.removeItem(item);
			}
		}
		else {
			localStorage.removeItem(item);
		}
	}
}

moment.locale("it");

$(window).on("online", function (e) {
	console.log(e);
	Shark.set("internetConnectionPresent", true);
	Shark.activePage.render();
});

$(window).on("offline", function (e) {
	console.log(e);
	Shark.set("internetConnectionPresent", false);
	Shark.activePage.render();
});

// Shark.openPage(loginView);

if (localStorage.getItem("sessionToken")) {
	const sessionToken = localStorage.getItem("sessionToken");

	driverManager.sessionCheck(sessionToken);
	driverManager.on("sessionAlive", function(event, data) {
		Shark.openPage(homeView);
	});
	driverManager.on("sessionExpired", loadLastUserName);
}
else {
	loadLastUserName();
}

function loadLastUserName(){
	// const lastUserName = localStorage.getItem("lastUserName") || "";

	// Shark.set("currUser", Shark.getInstance("User", {eMail: lastUserName}));
	// //Questo è ciò che mette sullo schermo la prima view. La view che vogliamo mostrare deve essere stata importata in alto per essere riconosciuta qui in fondo.
	Shark.openPage(loginView);
};
